import { Container, Paper } from "@mui/material";
import AddressAPI from "../../../../../../api/address";
import ContactAPI from "../../../../../../api/contactInfo";
import { Organization } from "../../../../../../model";
import { OrganizationAddressLabels } from "../../../../../../model/Address";
import { ContactLabels, ContactType } from "../../../../../../model/Contact";
import CreateOrganizationComponent from "../../../../../organization/components/CreateOrganizationComponent";
import {
  Task,
  TaskExecution,
  TaskExecutionComponentProps,
  TaskExecutionState,
} from "../../../../types";

const CreateOrganizationExecutionComponent = (
  props: TaskExecutionComponentProps<Task, TaskExecution>,
) => {
  return (
    <Container maxWidth="lg">
      <Paper elevation={2} sx={{ p: 4, borderRadius: "10px" }}>
        <CreateOrganizationComponent
          hideStepper={
            !props.isDisabled ||
            props.taskExecution?.state !== TaskExecutionState.Completed
          }
          /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
          organization={(props.taskExecution?.data as any)?.organization}
          disabled={props.taskExecution?.state === TaskExecutionState.Completed}
          buttonAlignment="right"
          buttonText="Continue"
          emailDisabled={true}
          onCreate={(organization: Organization, items) => {
            const executionData = {
              data: {
                organization: organization,
              },
            };

            const execution = {
              ...props.taskExecution,
              task_id: props.task.id,
              state: TaskExecutionState.Completed,
              ...executionData,
            };

            if (items) {
              if (items.billingAddress) {
                try {
                  AddressAPI.create(
                    items.billingAddress,
                    organization.id,
                    OrganizationAddressLabels.BILLING,
                  );
                } catch (e) {
                  console.error(e);
                }
              }

              if (items.primaryAddress) {
                try {
                  AddressAPI.create(
                    items.primaryAddress,
                    organization.id,
                    OrganizationAddressLabels.PRIMARY,
                  );
                } catch (e) {
                  console.error(e);
                }
              }

              if (items.billingPhone) {
                try {
                  ContactAPI.create({
                    organization_id: organization.id,
                    contact_type: ContactType.PHONE,
                    label: ContactLabels.BILLING,
                    value: items.billingPhone,
                    id: "",
                    user_id: "",
                  });
                } catch (e) {
                  console.error(e);
                }
              }

              if (items.billingEmail) {
                try {
                  ContactAPI.create({
                    organization_id: organization.id,
                    contact_type: ContactType.EMAIL,
                    label: ContactLabels.BILLING,
                    value: items.billingEmail,
                    id: "",
                    user_id: "",
                  });
                } catch (e) {
                  console.error(e);
                }
              }

              if (items.primaryEmail) {
                try {
                  ContactAPI.create({
                    organization_id: organization.id,
                    contact_type: ContactType.EMAIL,
                    label: ContactLabels.PRIMARY,
                    value: items.primaryEmail,
                    id: "",
                    user_id: "",
                  });
                } catch (e) {
                  console.error(e);
                }
              }

              if (items.primaryPhone) {
                try {
                  ContactAPI.create({
                    organization_id: organization.id,
                    contact_type: ContactType.PHONE,
                    label: ContactLabels.PRIMARY,
                    value: items.primaryPhone,
                    id: "",
                    user_id: "",
                  });
                } catch (e) {
                  console.error(e);
                }
              }
            }
            props.onExecute?.(execution as TaskExecution);
            props.onValueChange?.({ ...props.task, ...executionData } as Task);
          }}
        />
      </Paper>
    </Container>
  );
};

export default CreateOrganizationExecutionComponent;
